import HistoryIcon from '@mui/icons-material/History';
import { Button } from '@mui/material';
import { useState } from 'react';
import { ISolicitationViewModel } from 'viewModels';
import { ReactComponent as IconAttach } from '../../assets/icons/icon-attach.svg';
import { ReactComponent as IconChat } from '../../assets/icons/icon-chat.svg';
import { ReactComponent as IconDate } from '../../assets/icons/icon-edit-date.svg';
import { ReactComponent as IconObs } from '../../assets/icons/icon-obs.svg';
import { ReactComponent as IconDollar } from '../../assets/icons/iconDollar.svg';
import { ProfileType, RequestsSubmittedStatus, ServiceStatus, TypeUser } from '../../types/enums';
import { ModalAddAttachment } from '../Modals/ModalAddAttachment';
import { ModalAddDate } from '../Modals/ModalAddDate';
import { ModalAddObservation } from '../Modals/ModalAddObservation';
import { ModalChat } from '../Modals/ModalChat';
import { Container, Options } from './styles';
import { useConversation } from '../../context/conversation';
import { useAuth } from '../../context';
import { ModalSolicitationValue } from '../Modals/ModalSolicitationValue';

interface IOptionsEventSolicitations {
  solicitation: ISolicitationViewModel;
  isDemand: boolean;
  handleChangeHistoricVisible: (isVisible: boolean) => void;
  profileType?: ProfileType;
  zIndex?: number;
}

export function OptionsEventSolicitations({
  solicitation,
  isDemand,
  handleChangeHistoricVisible,
  profileType,
  zIndex,
}: IOptionsEventSolicitations) {
  const { user } = useAuth();
  const { getConversationIdByParticipantsIds } = useConversation();
  const [conversationIdSelected, setConversationIdSelected] = useState<string>();
  const [isOpenChat, setIsOpenChat] = useState(false);
  const [isOpenUpdateValue, setIsOpenUpdateValue] = useState(false);
  const [isOpenAddDate, setIsOpenAddDate] = useState(false);
  const [isOpenHistoric, setIsOpenHistoric] = useState(false);
  const [isOpenAddAttachment, setIsOpenAddAttachment] = useState(false);
  const [isOpenAddObservation, setIsOpenAddObservation] = useState(false);

  const handleClickOpenHistoric = () => {
    handleChangeHistoricVisible(!isOpenHistoric);
    setIsOpenHistoric(!isOpenHistoric);
  };

  const handleSelectConversation = () => {
    if (solicitation.userId && solicitation.correspondent?.id) {
      const participantsIds = [solicitation.userId, solicitation.correspondent.id];
      getConversationIdByParticipantsIds(participantsIds).then((conversationId) => {
        setConversationIdSelected(conversationId);
        setIsOpenChat(true);
      });
    }
  };

  const isRequester = !profileType || Number(profileType) === Number(ProfileType.REQUESTER);
  const isCorrespondent = solicitation.correspondent?.id === user.id || 
    solicitation.requestsSubmitted?.some(
      (r) => r.userId === user.id && r.status === RequestsSubmittedStatus.ACCEPT,
    );

  return (
    <Container>
      <Options>
        {(isRequester || Number(profileType) === Number(ProfileType.OPERATOR)) &&
          solicitation.status !== ServiceStatus.PENDING && (
            <div>
              <Button onClick={handleSelectConversation}>
                <IconChat className="icons" /> Abrir chat
              </Button>
            </div>
          )}
        {isRequester && (
          <>
            <div>
              <Button onClick={() => setIsOpenAddObservation(true)}>
                <IconObs className="icons" /> Anotações
              </Button>
            </div>
            <div>
              <Button onClick={() => setIsOpenAddAttachment(true)}>
                <IconAttach className="icons" /> Anexar
              </Button>
            </div>
            {!isDemand && (
              <div>
                <Button onClick={() => setIsOpenAddDate(true)}>
                  <IconDate className="icons" /> Nova data
                </Button>
              </div>
            )}
            {!isDemand && user.type === TypeUser.COMPANY && (
              <div>
                <Button onClick={() => setIsOpenUpdateValue(true)}>
                  <IconDollar className="icons" /> Novo valor
                </Button>
              </div>
            )}
          </>
        )}
        {(isRequester ||
          Number(profileType) === Number(ProfileType.OPERATOR) ||
          Number(profileType) === Number(ProfileType.APPROVER) ||
          isCorrespondent) && (
          <div>
            <Button onClick={handleClickOpenHistoric}>
              <HistoryIcon className="icons" /> Histórico
            </Button>
          </div>
        )}
      </Options>
      <ModalChat
        zIndex={zIndex}
        isOpen={isOpenChat}
        onRequestClose={() => setIsOpenChat(false)}
        conversationId={conversationIdSelected}
      />
      <ModalAddObservation
        zIndex={zIndex}
        isOpen={isOpenAddObservation}
        solicitationId={solicitation.id || ''}
        onRequestClose={() => setIsOpenAddObservation(false)}
      />
      <ModalAddAttachment
        zIndex={zIndex}
        isOpen={isOpenAddAttachment}
        solicitationId={solicitation.id || ''}
        onRequestClose={() => setIsOpenAddAttachment(false)}
      />
      <ModalSolicitationValue
        isOpen={isOpenUpdateValue}
        zIndex={zIndex}
        solicitation={solicitation}
        onRequestClose={() => setIsOpenUpdateValue(false)}
      />
      <ModalAddDate
        zIndex={zIndex}
        isOpen={isOpenAddDate}
        solicitation={solicitation}
        onRequestClose={() => setIsOpenAddDate(false)}
      />
    </Container>
  );
}
